import Service from "core/decorators/Service";
import ServiceRegistry from "core/util/ServiceRegistry";
import IRemoteConditionService, { RemoteCondition } from "../IRemoteConditionService";

@Service()
export default class DefaultRemoteConditionService extends IRemoteConditionService {

	public getServiceId(): string {
		return "default";
	}

	public evaluateConditions(externalIds: string[]): Promise<RemoteCondition[]> {
		return ServiceRegistry.getQueryService().findMany(RemoteCondition, {externalIds}).then((r: any) => r.data && r.data.entities || []);
	}

}



// WEBPACK FOOTER //
// ./src/core/service/remoteCondition/impl/DefaultRemoteCondition.service.ts